export default __webpack_public_path__ + "static/media/instrucciones_juego2.5fe6fe1e.png";